import React from 'react'
import { Link } from 'react-router-dom';

const AddClinicalStaff = () => {
  return (
    <main id="main" className="main">
		{/* Page Title Section */}
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>Add Clinical Staff</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to="/admin/dashboard">Home</Link></li>
					  <li className="breadcrumb-item"><Link to="physician.html">Clinical Staff</Link></li>
					  <li className="breadcrumb-item active">Add Clinical Staff </li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<Link to="#" /* onClick="window.history.back();" */ className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></Link>
			</div>{/* End Buttons */}
		</div>
		{/* End Page Title Section */}
		{/* Page Content Section */}
		<section>
		<div className="row">
			{/*ProfileImg*/}
			<div className="col-lg-4">
				<div className="card profile-img">
					<div className="card-body">
						<div className="upload-box d-none d-lg-block">		
							<div className="box text-center">
								<input type="file" name="file-5[]" id="file-5" className="inputfile inputfile-4" data-multiple-caption="{count} files selected" multiple="" />
								<label htmlFor="file-5">
									<img className="img-fluid d-block mx-auto" src="/assets/img/logo-img.png" />
									<span>Edit/Change <br /> (Drag and Drop)</span>
								</label>
							</div>
						</div>
						<div className="text-center text-tmBlue mt-4">
							<h6>Upload Picture</h6>
						</div>
					</div>
				</div>
            </div>
			{/*ProfileInfo*/}
			<div className="col-lg-8">
				<div className="card form-card profile-info ">
					<div className="card-body pt-4">
						<ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
						  <li className="nav-item" role="presentation">
							<Link className="nav-link active" id="pills-01-tab" data-bs-toggle="pill" to="#pills-01" role="tab" aria-controls="pills-01" aria-selected="true">Staff Info</Link>
						  </li>
						  <li className="nav-item" role="presentation">
							<Link className="nav-link" id="pills-02-tab" data-bs-toggle="pill" to="#pills-02" role="tab" aria-controls="pills-02" aria-selected="false">Hospital Info</Link>
						  </li>
						</ul>
						<div className="tab-content" id="pills-tabContent">							
							{/*TAB-01*/}
							<div className="tab-pane fade active show" id="pills-01" role="tabpanel" aria-labelledby="pills-01-tab">
								<form>
									<div className="row">
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>Staff Name </label>
												<input type="text" className="form-control" placeholder="Staff Name" />
											</div>
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>Staff Role </label>
												<input type="text" className="form-control" placeholder="Staff Role" />
											</div>
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>Phone Number</label>
												<input type="text" className="form-control" placeholder="+91 123 456 7890" />
											</div>
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>Email Address</label>
												<input type="text" className="form-control" placeholder="youremail@mail.com" />
											</div>
										</div>
									</div>
									{/*Prev-Next Button Section*/}
									<div className="row mt-3">								
										<div className="col-lg-12 text-end">
											<button type="button" className="btn btn-secondary btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> Prev</button>
											<button type="button" className="btn btn-tmBlue btnNext"><i className="ri-arrow-right-line align-middle"></i> Next</button>
										</div>
									</div>
								</form>
							</div>								
							{/*TAB-02*/}
							<div className="tab-pane fade" id="pills-02" role="tabpanel" aria-labelledby="pills-02-tab">
								<form>
									<div className="row">																						
										<div className="col-lg-12">
											<div className="form-group row">										
												<div className="col-lg-6 col-md-6 mb-3">
													<label>Hospital Name </label>
													<select className="form-select">
														<option >-- Select Patient --</option>
														<option value="1">Best Care Hospital</option>
														<option value="2">Healthy Kids Hospital</option>
														<option value="3">ABCD Children Hospital</option>
														<option value="4">Childcare Hospital</option>
														<option value="5">123 Kids Hospital</option>
													</select>
												</div>												
												<div className="col-lg-6 col-md-6 mb-3">
													<label>Working Days  </label>
													<div className="d-flex">
														<select className="form-select">
															<option >-- Select Day --</option>
															<option value="1">Monday</option>
															<option value="2">Tuesday</option>
															<option value="3">Wednesday</option>
															<option value="4">Thursday</option>
															<option value="5">Friday</option>
															<option value="6">Saturday</option>
															<option value="7">Sunday</option>
														</select>
														<div className="my-2 mx-3"> To </div>
														<select className="form-select">
															<option >-- Select Day --</option>
															<option value="1">Monday</option>
															<option value="2">Tuesday</option>
															<option value="3">Wednesday</option>
															<option value="4">Thursday</option>
															<option value="5">Friday</option>
															<option value="6">Saturday</option>
															<option value="7">Sunday</option>
														</select>
													</div>
												</div>											
												<div className="col-lg-5 col-md-4 mb-3">
													<label>Working Hours  </label>
													<div className="d-flex">
														<input type="time" className="form-control" />
														<div className="my-2 mx-3"> To </div>
														<input type="time" className="form-control" />
													</div>
												</div>											
												<div className="col-lg-1 col-md-2  mb-3">
													<label>&nbsp; </label>
													<button type="button" className="btn btn-outline-tmBlue py-2 btn-48px" /* onClick="parient_fields();" */><i className="ri-add-fill align-middle"></i></button>
												</div>
											</div>	
											<div id="organisation_fields"></div>	
										</div>	
									</div>
									
									{/*Prev-Next Button Section*/}
									<div className="row">								
										<div className="col-lg-12 text-end">
											<Link className="btn btn-secondary btnPrev me-2" ><i className="ri-arrow-left-line align-middle"></i> Prev</Link>
											<Link className="btn btn-tmBlue" to="/admin/view-clinical-staff"><i className="ri-check-double-fill align-middle"></i> Submit</Link>
										</div>
									</div>
								</form>
							</div>	
						</div>
					</div>
				</div>
            </div>
        </div>
    </section>
		{/* End Page Content Section */}
	</main>
  )
}

export default AddClinicalStaff
